import React, { useEffect, useRef } from 'react';
import Phaser from 'phaser';
import createGameConfig from '../game/GameConfig';

const GamePage = () => {
  const gameRef = useRef(null);
  const gameInstanceRef = useRef(null);

  useEffect(() => {
    // Initialize game
    if (gameRef.current && !gameInstanceRef.current) {
      const config = createGameConfig(gameRef.current);
      gameInstanceRef.current = new Phaser.Game(config);
    }

    // Cleanup on unmount
    return () => {
      if (gameInstanceRef.current) {
        gameInstanceRef.current.destroy(true);
        gameInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0505] flex flex-col items-center justify-center">
      {/* Game Header */}
      <div className="w-full max-w-[1280px] px-4 py-4 flex justify-between items-center">
        <a 
          href="/" 
          className="text-accent hover:text-white transition-colors font-manrope"
        >
          ← Back to MGN1.6
        </a>
        <h1 className="text-xl font-playfair text-accent">
          Anunnaki vs Humans
        </h1>
        <div className="text-xs text-gray-500">
          v0.1.0 Development Build
        </div>
      </div>

      {/* Game Container */}
      <div 
        ref={gameRef} 
        id="game-container"
        className="border-2 border-accent/30 rounded-lg overflow-hidden shadow-2xl"
        style={{
          width: '1280px',
          height: '720px',
          maxWidth: '100vw',
          maxHeight: 'calc(100vh - 120px)'
        }}
        data-testid="game-container"
      />

      {/* Controls Guide */}
      <div className="w-full max-w-[1280px] px-4 py-4 text-center text-gray-500 text-sm">
        <span className="mr-6"><kbd className="bg-gray-800 px-2 py-1 rounded">W A S D</kbd> Move</span>
        <span className="mr-6"><kbd className="bg-gray-800 px-2 py-1 rounded">SPACE</kbd> Action</span>
        <span><kbd className="bg-gray-800 px-2 py-1 rounded">ESC</kbd> Pause Menu</span>
      </div>

      {/* Development Notice */}
      <div className="fixed bottom-4 right-4 bg-amber-900/80 text-amber-200 px-4 py-2 rounded-lg text-sm">
        🚧 Game in Development - Sprites & Graphics Needed
      </div>
    </div>
  );
};

export default GamePage;
